import type { SchedulerSettings } from 'api/schema/models/SchedulerSettings'

/** Stored in except_days_descriptions when moving one occurrence (not a user cancel reason). */
export const TASK_RESCHEDULE_REASON = 'Rescheduled'

export function isRescheduleDescription(reason: string | null | undefined): boolean {
  return String(reason || '').trim().toLowerCase() === TASK_RESCHEDULE_REASON.toLowerCase()
}

export function isRescheduledOccurrence(
  settings: Pick<SchedulerSettings, 'except_days' | 'except_days_descriptions'> | null | undefined,
  dateStr: string
): boolean {
  if (!settings?.except_days?.includes(dateStr)) return false
  return isRescheduleDescription(settings.except_days_descriptions?.[dateStr])
}

/** Parent series: skip the original day on the robot, mark the skip as a reschedule for FMS UI. */
export function withSingleOccurrenceReschedule(
  parentSettings: SchedulerSettings,
  originalDate: string
): SchedulerSettings {
  const except_days = [...(parentSettings.except_days || [])]
  if (!except_days.includes(originalDate)) {
    except_days.push(originalDate)
    except_days.sort()
  }
  return {
    ...parentSettings,
    except_days,
    except_days_descriptions: {
      ...(parentSettings.except_days_descriptions || {}),
      [originalDate]: TASK_RESCHEDULE_REASON,
    },
  }
}

export function hasRecurringWeekdays(
  weekdays: SchedulerSettings['weekdays'] | null | undefined
): weekdays is NonNullable<SchedulerSettings['weekdays']> {
  if (!weekdays) return false
  return Object.values(weekdays).some(value => String(value).toLowerCase() === 'true')
}
